export default "__VITE_ASSET__2bbd8be9__"